import { inject, Injectable } from '@angular/core';
import { UseCase } from '@shared/helper';
import { catchError, Observable, throwError } from 'rxjs';
import { ErrorMessageService } from '@shared/services/error-message/error-message.service';
import { CreateOrderPackageDto } from './create-order-package.interface';
import { CheckoutRepository } from '@data/repositories/checkout.repository';
import { OrderData } from '@data/domain/checkout.entity';
@Injectable({
    providedIn: 'root'
})
export class CreateOrderPackageUsecase implements UseCase<CreateOrderPackageDto, OrderData> {
    private readonly checkoutRepository = inject(CheckoutRepository);
    private readonly errorMesssageService = inject(ErrorMessageService);

    execute(params: CreateOrderPackageDto): Observable<OrderData> {
        return this.checkoutRepository.CreateOrderPackage(params).pipe(
            catchError((error) => {
                const {status_code, msisdn} = error;
                return throwError(() => this.errorMesssageService.getErrorMessage(status_code, msisdn));
            })
        );
    }
}